/**
 * WordPress dependencies
 */
import { _x } from '@wordpress/i18n';

export default {
	name: 'core/pattern-overrides',
	label: _x( 'Pattern Overrides', 'block bindings source' ),
	useSource: null,
	lockAttributesEditing: false,
};
